// extracted by mini-css-extract-plugin
export default {"zoomModal":"Q3-z"};